import moment from 'moment';

moment.locale('fr');
export const DATE_FORMATS = Object.freeze({
  DDMMYYYY: 'DD.MM.YYYY',
  INPUT_TYPE_DATE: 'YYYY-MM-DD',
});

export function formatDateToLocalDateFormat(value) {
  if (!value) return '';
  const dateArray = moment(value).toArray().slice(0, 3);
  dateArray[1] += 1;
  return dateArray;
}

export function formatJacksonDateForInputTypeDate(value) {
  if (!value) return '';
  const dateArrayClone = value.slice(0);
  dateArrayClone[1] -= 1;
  return moment(dateArrayClone).format(DATE_FORMATS.INPUT_TYPE_DATE);
}

export function formatDateDDMMYYYY(value) {
  if (!value) return '';
  return moment(value).format(DATE_FORMATS.DDMMYYYY);
}

export function formatJacksonDateToDDMMYYYY(value) {
  return formatDateDDMMYYYY(formatJacksonDateForInputTypeDate(value));
}
